import { useState } from 'react';
import { faqs, voices } from '@/mocks/gossip';

export function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[380px_1fr]">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <span className="text-sm font-semibold text-primary-500">FAQ · 常见问题</span>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
              吃瓜前，先弄清这些
            </h2>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600 md:text-base">
              关于吃瓜cb的内容更新、可靠性、投稿方式与使用体验，你想知道的都在这里。还有疑问？欢迎到投稿区留言。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-2xl border border-background-200 bg-background-100 p-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                <i className="ri-chat-smile-3-line"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-900">边吃边看遇到问题？</p>
                <a href="#submit" className="text-sm font-semibold text-primary-600 hover:text-primary-700">
                  找瓜友会客厅聊聊 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen ? 'border-primary-300 bg-primary-50/60' : 'border-background-200 bg-background-100'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <h3 className="text-base font-bold text-foreground-950">{f.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-all ${
                        isOpen
                          ? 'rotate-45 bg-primary-500 text-white'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pt-0">
                      <p className="border-t border-primary-200 pt-3 text-sm leading-7 text-foreground-700">
                        {f.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export function VoiceSection() {
  return (
    <section id="voice" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center gap-2 text-center">
          <span className="text-sm font-semibold text-primary-500">VOICE · 瓜友口碑</span>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            一起边吃边看的人越来越多
          </h2>
          <p className="max-w-xl text-sm text-foreground-600 md:text-base">
            上千位瓜友正在把吃瓜cb当成每日下饭搭子，看看大家都怎么说。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {voices.map((v) => (
            <article
              key={v.nick}
              className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-transform hover:-translate-y-1"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-base font-bold text-secondary-700">
                    {v.nick.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{v.nick}</p>
                    <p className="text-xs text-foreground-500">{v.role}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 text-accent-500">
                  {Array.from({ length: v.stars }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">
                <i className="ri-double-quotes-l text-primary-400"></i>
                {v.text}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-9 flex flex-col items-center gap-4 rounded-3xl bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-10 text-center md:flex-row md:justify-between md:text-left">
          <div>
            <h3 className="font-display text-2xl text-white">就差你这一双筷子了</h3>
            <p className="mt-1 text-sm text-white/85">
              开动好奇心，端起你的饭碗，一起开吃今晚这份热乎的瓜。
            </p>
          </div>
          <a
            href="#feed"
            className="whitespace-nowrap rounded-full bg-accent-400 px-7 py-3 text-base font-bold text-foreground-950 transition-colors hover:bg-accent-300"
          >
            立刻开吃
          </a>
        </div>
      </div>
    </section>
  );
}